module.exports = __webpack_public_path__ + "static/img/godwealth_en.6cc0e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/godwealth_en.png
// module id = 84Lz
// module chunks = 1